import JSZip from 'jszip'
import { DocumentAPIResponse } from '@/lib/redpim'

export async function downloadAllProductResourcesAsZip(
	documents: DocumentAPIResponse,
	partNumber: string,
) {
	const zip = new JSZip()
	let hasFiles = false

	// Fonction helper pour ajouter des fichiers à partir d'une section
	const addFilesFromSection = async (files: any[], folderName: string) => {
		if (!files || files.length === 0) return

		hasFiles = true
		const folder = zip.folder(folderName)

		for (const file of files) {
			try {
				// Télécharger le fichier via notre API proxy pour éviter les CORS
				const proxyUrl = `/api/download-file?url=${encodeURIComponent(file.item_path)}`
				const response = await fetch(proxyUrl)
				if (!response.ok) {
					console.warn(`Failed to download ${file.metadata_storage_name}`)
					continue
				}

				const blob = await response.blob()
				const fileName = file.metadata_storage_name || `file_${Date.now()}.pdf`

				folder?.file(fileName, blob)
			} catch (error) {
				console.error(`Error downloading ${file.metadata_storage_name}:`, error)
			}
		}
	}

	// Ajouter les fichiers de chaque section
	await addFilesFromSection(documents.cadFiles?.value || [], 'CAD_Files')
	await addFilesFromSection(documents.userManuals?.value || [], 'User_Manuals')
	await addFilesFromSection(
		documents.safetyInstructions?.value || [],
		'Safety_Instructions',
	)
	await addFilesFromSection(
		documents.complianceCertificates?.value || [],
		'Compliance_Certificates',
	)

	// Gérer les certificats de calibration (structure différente)
	if (documents.calibrationCertificates?.original?.value) {
		await addFilesFromSection(
			documents.calibrationCertificates.original.value,
			'Calibration_Certificates',
		)
	}

	if (!hasFiles) {
		throw new Error('Aucun fichier disponible pour le téléchargement')
	}

	// Générer et télécharger le zip
	try {
		const zipBlob = await zip.generateAsync({ type: 'blob' })
		const url = URL.createObjectURL(zipBlob)

		const link = document.createElement('a')
		link.href = url
		link.download = `${partNumber}_documents.zip`
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)

		// Nettoyer l'URL
		URL.revokeObjectURL(url)
	} catch (error) {
		console.error('Error generating zip:', error)
		throw new Error('Erreur lors de la génération du fichier zip')
	}
}
